import { useMutation } from "@tanstack/react-query";
import { saveInclusiveContentApiCall } from "./utils.api";

export const useSaveInclusiveContent = () =>
    useMutation({
        mutationFn: (body) =>
            saveInclusiveContentApiCall(body),
    });